const defaultFormatter = { currency: "USD" };

export { defaultFormatter };
//# sourceMappingURL=bundle.esm3.js.map
